import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  
`

const Container = props => {
  return <Wrapper>{props.children}</Wrapper>
}

export default Container



// WEBPACK FOOTER //
// ./src/components/Container.js